import React, { useEffect } from "react";
import "./Projects.css";
import emajohn from "../ProjectImg/emaJohn.jpg";
import airbnb from "../ProjectImg/airbnbClone.jpg";
import coding from "../ProjectImg/codingPremiarleage.jpg";
import hungry from "../ProjectImg/hungryMonster.jpg";
import material from "../ProjectImg/photoAlbum.jpg";
import pinterst from "../ProjectImg/pinterestClone.jpg";
import res from "../ProjectImg/responSive.jpg";
import youtube from "../ProjectImg/youtubeClone.jpg";
import TechSoftware from "../ProjectImg/techsoftware.jpg";
import bikezone from "../ProjectImg/bikezone.jpg";
import roadking from "../ProjectImg/roadkingrider.jpg";
import professionalSports from "../ProjectImg/professionalSportsLeagues.jpg";

import aos from "aos";
import "aos/dist/aos.css";
const Projects = () => {
  document.title = "💻 Projects | Rian Islam";

  useEffect(() => {
    aos.init({ duration: 2000 });
  }, []);


  return (
    <div className="container">
      <div className="Heading py-5">
        <h1 data-aos="fade-right">Projects</h1>
        <p data-aos="fade-left">Here are some Application that I have devoloped.</p>
      </div>




      <div  className="row row-cols-1 row-cols-md-3 g-4 mb-5 pb-5">

     {/* TechSoftware */}
     
      <div data-aos="fade-up" className="col project-hover p-3 rounded">
          <div style={{backgroundColor:"#000"}} className="card project-semibox h-100 project-semibox   shadow">
            <div style={{ borderRadius: "20px" }} className="m-3 bg-light">
              <img
                style={{ border: "1px solid gray" }}
                src={TechSoftware}
                className="card-img-top"
                alt="..."
              />
            </div>
            <div className="card-body">
              <h3 className="card-title">
                <a
                  target="_blank"
                  href="https://repair-items.web.app/"
                >
                 TechSoftware
                </a>
              </h3>
              <p className="card-text">
                repair center website,Users can take service and give feedback.
                </p>
              <h5>Technology:</h5>
              <p className="card-text">
                React,Node Js,Express Js,Firebase,React-hook,React-router,ContextApi
              </p>
            </div>
          </div>
        </div>


     {/* bike zone */}
     
      <div data-aos="fade-up" className="col project-hover p-3 rounded">
          <div style={{backgroundColor:"#000"}} className="card h-100 project-semibox   shadow">
            <div style={{ borderRadius: "20px" }} className="m-3 bg-light">
              <img
                style={{ border: "1px solid gray" }}
                src={bikezone}
                className="card-img-top"
                alt="..."
              />
            </div>
            <div className="card-body">
              <h3 className="card-title">
                <a
                  target="_blank"
                  href="https://bike-zone-franz.web.app/"
                >
                 Bike Zone
                </a>
              </h3>
              <p className="card-text">
              bike showroom website. Users can show details about the bike, order
              the bike and show their own order list.
                </p>
              <h5>Technology:</h5>
              <p className="card-text">
                React,Node Js,Express Js,Firebase,React-hook,React-router,ContextApi
              </p>
            </div>
          </div>
        </div>



     {/* Road King Rider */}
     
      <div data-aos="fade-up" className="col project-hover p-3 rounded">
          <div style={{backgroundColor:"#000"}} className="card h-100 project-semibox   shadow">
            <div style={{ borderRadius: "20px" }} className="m-3 bg-light">
              <img
                style={{ border: "1px solid gray" }}
                src={roadking}
                className="card-img-top"
                alt="..."
              />
            </div>
            <div className="card-body">
              <h3 className="card-title">
                <a
                  target="_blank"
                  href="https://react-auth-rianislam.web.app/"
                >
                 Road King Rider
                </a>
              </h3>
              <p className="card-text">
              
              Simple react router web site.load data using fake api.
                </p>
              <h5>Technology:</h5>
              <p className="card-text">
                React,Firebase,React-hook,React-router,ContextApi
              </p>
            </div>
          </div>
        </div>



{/* airbnbClone */}

        {/* <div data-aos="fade-up" className="col project-hover p-3 rounded">
          <div style={{backgroundColor:"#000"}} className="card h-100 project-semibox shadow">
            <div style={{ borderRadius: "20px" }} className="m-3  bg-light">
              <img
                style={{ border: "1px solid gray" }}
                src={airbnb}
                className="card-img-top"
                alt="..."
              />
            </div>
            <div className="card-body">
              <h3 className="card-title">
                <a target="_blank" href="https://reactjs-airbnb-clone.web.app/">
                  Airbnb Clone
                </a>
              </h3>
              <p className="card-text">
              clone Airbnb
         </p>
              <h5>Technology:</h5>
              <p className="card-text">
                React,React-hook,React-router,Firebase
              </p>
            </div>
          </div>
        </div> */}

{/* emajohn */}


        <div data-aos="fade-up" className="col project-hover p-3 rounded">
          <div style={{backgroundColor:"#000"}} className="card h-100 project-semibox   shadow">
            <div style={{ borderRadius: "20px" }} className="m-3 bg-light">
              <img
                style={{ border: "1px solid gray" }}
                src={emajohn}
                className="card-img-top"
                alt="..."
              />
            </div>
            <div className="card-body">
              <h3 className="card-title">
                <a
                  target="_blank"
                  href="https://frosty-payne-ce890a.netlify.app/"
                >
                  Ema-John
                </a>
              </h3>
              <p className="card-text">
                    E-commerce website            
                  </p>
              <h5>Technology:</h5>
              <p className="card-text">
                React,React-hook,React-router,ContextApi
              </p>
            </div>
          </div>
        </div>

{/* responSive */}

        <div data-aos="fade-up" className="col project-hover p-3 rounded">
          <div style={{backgroundColor:"#000"}} className="card h-100 project-semibox   shadow">
            <div style={{ borderRadius: "20px" }} className="m-3 bg-light">
              <img
                style={{ border: "1px solid gray" }}
                src={res}
                className="card-img-top"
                alt="..."
              />
            </div>
            <div className="card-body">
              <h3 className="card-title">
                <a
                  target="_blank"
                  href="https://rianislam.github.io/Responsive-Website/"
                >
                  Shopping
                </a>
              </h3>
              <p className="card-text">
              Simple Shoping website.
                </p>
              <h5>Technology:</h5>
              <p className="card-text">HTM,CSS,Bootstrap</p>
            </div>
          </div>
        </div>

        {/* professional leagues */}


        <div data-aos="fade-up" className="col  project-hover p-3 rounded">
          <div style={{backgroundColor:"#000"}} className="card h-100 project-semibox   shadow">
            <div style={{ borderRadius: "20px" }} className="m-3 bg-light">
              <img
                style={{ border: "1px solid gray" }}
                src={professionalSports}
                className="card-img-top"
                alt="..."
              />
            </div>
            <div className="card-body">
              <h3 className="card-title">
                <a
                  target="_blank"
                  href="https://professional-sports-leagues.web.app/"
                >
                  Professional Sports Leagues
                </a>
              </h3>
              <p className="card-text">
              
              Simple react router web site.load data using sportsdb api.
                </p>
              <h5>Technology:</h5>
              <p className="card-text">
                React,React-hook,React-router,Firebase for Hosting
              </p>
            </div>
          </div>
        </div>

{/* youtube */}

        {/* <div data-aos="fade-up" className="col project-hover p-3 rounded">
          <div style={{backgroundColor:"#000"}} className="card h-100 project-semibox   shadow">
            <div style={{ borderRadius: "20px" }} className="m-3 bg-light">
              <img
                style={{ border: "1px solid gray" }}
                src={youtube}
                className="card-img-top"
                alt="..."
              />
            </div>
            <div className="card-body">
              <h3 className="card-title">
                <a target="_blank" href="https://clone-60590.web.app/">
                  YouTube Clone
                </a>
              </h3>
              <p className="card-text">
                Try to clone YouTube
                </p>
              <h5>Technology:</h5>
              <p className="card-text">
                React,React-hook,React-router,Firebase
              </p>
            </div>
          </div>
        </div> */}


        {/* pinterst project */}


        {/* <div data-aos="fade-up" className="col project-hover p-3 rounded">
          <div style={{backgroundColor:"#000"}} className="card h-100 project-semibox   shadow">
            <div style={{ borderRadius: "20px" }} className="m-3 bg-light">
              <img
                style={{ border: "1px solid gray" }}
                src={pinterst}
                className="card-img-top"
                alt="..."
              />
            </div>
            <div className="card-body">
              <h3 className="card-title">
                <a target="_blank" href="https://pinterest-d0ef2.web.app/">
                  Pinterest Clone
                </a>
              </h3>
              <p className="card-text">
              Try to clone Pinterest.Using Unsplash Api
                </p>
              <h5>Technology:</h5>
              <p className="card-text">
                React,React-hook,React-router,Firebase
              </p>
            </div>
          </div>
        </div> */}



{/* material ui */}


        {/* <div data-aos="fade-up" className="col project-hover p-3 rounded">
          <div style={{backgroundColor:"#000"}} className="card h-100 project-semibox   shadow">
            <div style={{ borderRadius: "20px" }} className=" m-3 bg-light">
              <img
                style={{ border: "1px solid gray" }}
                src={material}
                className="card-img-top"
                alt="..."
              />
            </div>
            <div className="card-body">
              <h3 className="card-title">
                <a
                  target="_blank"
                  href="https://material-ui-project-1.web.app/"
                >
                  Material Ui
                </a>
              </h3>
              <p className="card-text">
              Using Material Ui
                </p>
              <h5>Technology:</h5>
              <p className="card-text">React js,Material Ui</p>
            </div>
          </div>
        </div> */}



        {/* Hungry Monstar */}

        <div data-aos="fade-up" className="col project-hover p-3 rounded">
          <div style={{backgroundColor:"#000"}} className="card h-100 project-semibox   shadow">
            <div style={{ borderRadius: "20px" }} className=" m-3 bg-light">
              <img
                style={{ border: "1px solid gray" }}
                src={hungry}
                className="card-img-top"
                alt="..."
              />
            </div>
            <div className="card-body">
              <h3 className="card-title">
              
                <a
                  target="_blank"
                  href="https://rianislam.github.io/Hungry-Monster/"
                >
                  Hungry Monster
                </a>
              </h3>
              <p className="card-text">
              User Can search Any food and see how to made
                </p>
              <h5>Technology:</h5>
              <p className="card-text">Using javascript,Food Api</p>
            </div>
          </div>
        </div>

      {/* coding codingPremiarleage */}

        <div data-aos="fade-up" className="col  project-hover p-3 rounded">
          <div style={{backgroundColor:"#000"}} className="card h-100 project-semibox   shadow">
            <div style={{ borderRadius: "20px" }} className=" m-3 bg-light">
              <img
                style={{ border: "1px solid gray" }}
                src={coding}
                className="card-img-top"
                alt="..."
              />
            </div>
            <div className="card-body">
              <h3 className="card-title">
                
                <a
                  target="_blank"
                  href="https://cocky-wright-6e5612.netlify.app/"
                >
                  Coding Premiar League
                </a>
              </h3>
              <p className="card-text">
              User can add their player.
                </p>
              <h5>Technology:</h5>
              <p className="card-text">React,React-hook,React-router</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Projects;
